// แก้ส่วนลดด้วยมือ — กฎเดียวกับ backend/utils/channelMap.js canEditManualDiscount (server ตรวจซ้ำ)
// เซลล์เครดิต/ออนไลน์/หน้าร้านทุกสาขา + ธุรการเซลล์ ทุกระดับผู้ใช้ และผู้มีสิทธิ์เดิม (level ≥ 2, ฝ่ายขาย)
const SALES_CHANNEL_GROUPS = ['แผนกขายเครดิต', 'แผนกขายออนไลน์', 'แผนกขายหน้าร้าน']; // ตรงบางส่วน (includes)
const WALKIN_BRANCH_GROUPS = ['ขายหน้าร้านสันทราย', 'ขายหน้าร้านสันกำแพง'];           // ตรงทั้งคำ
const SALES_ADMIN_GROUPS = ['แผนกธุรการเซลล์', 'ธุรการเซลล์เครดิต', 'ธุรการเซลล์ออนไลน์']; // ตรงทั้งคำ

export function canEditManualDiscount(user) {
  if (!user) return false;
  if (Number(user.user_level) >= 2) return true;
  const dept = Array.isArray(user.dept) ? user.dept : [];
  if (dept.includes('ฝ่ายขาย')) return true;
  return dept.some(g => {
    const s = String(g);
    return SALES_CHANNEL_GROUPS.some(c => s.includes(c))
      || WALKIN_BRANCH_GROUPS.includes(s.trim())
      || SALES_ADMIN_GROUPS.includes(s.trim());
  });
}
